import { animationRegistry } from "./animationRegistry";

export const buildAnimationProps = (action) => {
  const strategy = animationRegistry[action.type];

  if (!strategy) {
    console.warn(`No animation strategy found for "${action.type}"`);
    return null;
  }

  return {
    ...strategy(action),
    duration: action.duration,
    ease: action.ease,
  };
};


// animationBuilder is just a helper function that:
// Finds the correct strategy.
// Builds the GSAP properties.
// Adds common properties (duration, ease, etc.).
// Validates that the strategy exists.